import { pagesPlacesLaborCoreEn } from './labor-core';
import { pagesPlacesSettingsEn } from './settings/default';
export const pagesPlacesEn = {
  shared: {
    placeStatus: 'Place Status',
    status: {
      ACTIVE: 'Active',
      CLOSED: 'Closed',
      PLANNED: 'Planned',
      PLANNED_CLOSURE: 'Planned Closure',
      SUSPENDED: 'Suspended',
      TEMPORARILY_CLOSED: 'Temporarily Closed',
      UNDER_CONSTRUCTION: 'Under Construction',
      UNDER_RENOVATION: 'Under Renovation'
    }
  },
  laborCore: pagesPlacesLaborCoreEn,
  settings: pagesPlacesSettingsEn,
  overview: {
    slot: {
      activity: {
        empty: 'No recent activity',
        title: 'Place Activity',
        types: {
          ADDED: 'Place added'
        }
      },
      businessPlaceType: {
        title: 'Business Type'
      },
      ownershipType: {
        title: 'Ownership Type'
      },
      timeSeries: {
        addedLabel: 'Added',
        cumulativeLabel: 'Cumulative',
        title: 'Registered Places'
      },
      total: {
        title: 'Places'
      },
      workStyle: {
        title: 'Work Style'
      }
    },
    unit: {
      others: 'Others',
      places: 'places',
      types: 'types'
    }
  },
  list: {
    addPlace: 'Add Place',
    filterPlaceholder: 'Search by place name',
    filters: {
      businessPlaceType: 'Business place type',
      businessPlaceTypePlaceholder: 'Search by business place type',
      officeType: 'Office type',
      officeTypePlaceholder: 'Search by office type',
      ownershipType: 'Ownership type',
      ownershipTypePlaceholder: 'Search by ownership type'
    },
    pageTitle: 'Places',
    tabs: {
      active: 'Active',
      all: 'All',
      closed: 'Closed',
      planned: 'Planned',
      temporarilyClosed: 'Temporarily Closed'
    }
  },
  add: {
    progressbar: {
      filled: 'filled',
      left: '{{value}}left',
      modeSetting: 'Mode Settings',
      mustItem: 'Must Item',
      mustItemOnly: 'Must item only',
      total: 'Total'
    },
    submitButtonLabel: 'Submit',
    title: 'Add Place'
  },
  addSelect: {
    body: {
      fillOutDetails: 'Fill Out Details',
      itemCard: {
        address: 'Street Address',
        basicInfo: 'Basic Information',
        businessHours: 'Business Hours',
        city: 'City',
        contactInfo: 'Contact Information',
        placeName: 'Place Name',
        postalCode: 'Postal Code',
        prefecture: 'Prefecture',
        requiredDetails: 'Required Fields',
        securityInfo: 'Security Information',
        storageInfo: 'Storage Facility Info'
      },
      place: 'Place',
      selectPlaceType: 'Please select the type of place you want to add'
    },
    header: {
      headerTitle: 'Select Place Type'
    },
    options: {
      bulkCsvUpload: {
        button: 'Upload CSV',
        description: 'You can add data for multiple places, up to 500 records at a time. A CSV file following the DRESS CODE format is required.',
        title: 'Bulk Upload via CSV'
      },
      bulkRegister: 'Sync with External System',
      description: 'Or...'
    }
  },
  administrators: {
    addAdministrator: 'Add Oversight Person',
    addAdministratorDialog: {
      confirm: 'Add',
      person: 'Person',
      role: 'Role',
      success: 'Added oversight person successfully',
      title: 'Add Oversight Person'
    },
    assignPrimaryDialog: {
      confirm: '{{personName}} will be set as the primary oversight person of {{roleName}}.',
      success: 'Set to primary successfully',
      title: 'Set to Primary'
    },
    filterPlaceholder: 'Search by member name, email',
    filters: {
      role: 'Role',
      rolePlaceholder: 'Search by role'
    },
    pageTitle: 'Place Oversight Persons',
    primary: 'Primary',
    setToPrimary: 'Set to Primary',
    tabs: {
      all: 'All',
      primary: 'Primary'
    },
    unassign: 'Unassign',
    unassignDialog: {
      confirm: 'Are you sure you want to unassign {{personName}} from {{roleName}}?',
      success: 'Unassigned successfully',
      title: 'Unassign',
      unassign: 'Unassign'
    }
  },
  importCsv: {
    columns: {
      businessPlaceType: 'Business Place Type',
      city: 'City',
      code: 'Place Code',
      email: 'Email',
      maxCapacity: 'Max Capacity',
      name: 'Place Name',
      officeType: 'Office Type',
      phoneNumber: 'Phone Number',
      postalCode: 'Postal Code',
      stateProvince: 'State/Province',
      status: 'Status',
      streetAddress: 'Street Address'
    },
    completeDialog: {
      button: 'Return to Places List'
    },
    exportFilename: 'places-list',
    prepareCsvFile: {
      templateTitle: 'Place CSV Template',
      updateExisting: 'To update existing place information, include the Place ID'
    },
    title: 'Bulk Import Places from CSV',
    unit: 'items'
  },
  profile: {
    itemCard: {
      businessPlaceType: 'Business place type',
      closingDate: 'Closing date',
      description: 'Description',
      establishedDate: 'Established date',
      officeType: 'Office type',
      ownershipType: 'Ownership type',
      placeCode: 'Place code',
      placeImage: 'Place image',
      placeName: 'Place name',
      placeStatus: 'Place status',
      startOfOperationDate: 'Start of operation date',
      subCodes: 'Sub codes',
      address: 'Address',
      mainEmail: 'Main email',
      mainFaxNumber: 'Main fax number',
      mainPhoneNumber: 'Main phone number',
      websiteUrl: 'Website URL',
      administratorName: 'Administrator name',
      hasCafeteria: 'Has cafeteria',
      hasFitnessCenter: 'Has fitness center',
      hasSecurityAccessControl: 'Has security access control',
      hasSecurityCameras: 'Has security cameras',
      hasSecurityGuards: 'Has security guards',
      maxCapacityOfPersons: 'Max capacity of persons',
      meetingRoomCount: 'Meeting room count',
      parkingSpaceCount: 'Parking space count',
      totalArea: 'Area',
      businessHours: 'Business hours',
      businessHoursEnd: 'End',
      businessHoursStart: 'Start',
      hasFlexTime: 'Has flex time',
      hasLocalHolidays: 'Has local holidays',
      leaseContractNumber: 'Lease contract number',
      leaseEndDate: 'Lease end date',
      leaseRenewalDate: 'Lease renewal date',
      leaseStartDate: 'Lease start date',
      localHolidayMemo: 'Local holiday description',
      workStyle: 'Work style'
    },
    navigation: {
      address: 'Address',
      admin: 'Place Administrator',
      contact: 'Contact',
      facility: 'Facility',
      operatingInfo: 'Operating Info',
      placeIdInfo: 'Place ID Info'
    },
    subCodes: {
      actions: {
        add: 'Add sub code'
      },
      empty: 'No sub codes',
      header: {
        code: 'Sub code',
        name: 'Sub code name'
      },
      placeholder: 'Select a sub code'
    }
  }
};